import React, { useRef } from 'react';
import {
  Link,
  useNavigate,
  useRouter,
  useSearch,
} from '@tanstack/react-router';

import { useStore } from '../store';

interface SearchFieldProps {
  placeholder?: string;
};

const SearchField: React.FC<SearchFieldProps> = ({ placeholder = 'Search users...' }) => {
  const { search } = useSearch({ strict: false });
  const navigate = useNavigate();
  const router = useRouter();
  const searching = useStore.getState().searching;
  const inputRef = useRef<HTMLInputElement>(null);

  const handleSearch = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter') {
      const target = event.target as HTMLInputElement;
      const value = target.value;
      useStore.setState({ searching: true });
      navigate({
        to: '.',
        search: (prev: any) => ({
          ...prev,
          search: value || undefined,
        }),
      });
      router.invalidate({
        filter: (route) => {
          return route.routeId === window.location.pathname;
        },
      });
    }
  };

  return (
    <div className="search">
      <div>
        <input
          type="text"
          name="search"
          placeholder={placeholder}
          defaultValue={search || ''}
          onKeyDown={handleSearch}
          disabled={searching}
          ref={inputRef}
        />
        {search && (
          <Link
            to="."
            search={(prev: any) => ({
              ...prev,
              search: undefined,
            })}
            disabled={searching}
            onClick={() => {
              useStore.setState({ searching: true });
              if (inputRef.current) {
                inputRef.current.value = '';
              }
              router.invalidate({
                filter: (route) => {
                  return route.routeId === window.location.pathname;
                },
              });
            }}
          >
            <span className="clear">clear</span>
          </Link>
        )}
      </div>
    </div>
  );
}

export default SearchField;
